import React, { useEffect, useState } from 'react';
import {
  Stack, Container, Typography, Button, Box, Paper, Divider, Badge
} from '@mui/material';
import { useEffectAsync } from '../reactHelper';
import { prefixString } from '../common/util/stringUtils';
import { useTranslation } from '../common/components/LocalizationProvider';
import { useTheme } from '@mui/material/styles';
import SettingsStyles from './utils/SettingsStyles';
import PageLayout from '../common/components/PageLayout';
import CollectionFab from './components/CollectionFab';
import {ReactComponent as NotificationIcon} from '../resources/images/track2you/Icons_Notification.svg';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { filterByKeyword } from './components/SearchHeader';
import LoadingPage from '../LoadingPage';  // Adjust the path based on your directory structure


const NotificationsPage = () => {
  //const classes = useSettingsStyles();
  const t = useTranslation();
  const theme = useTheme();
  const classes = SettingsStyles();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/notifications');
      if (response.ok) {
        setItems(await response.json());
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  const formatList = (prefix, value) => {
    if (value) {
      return value
        .split(/[, ]+/)
        .filter(Boolean)
        .map((it) => t(prefixString(prefix, it)))
        .join(', ');
    }
    return '';
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#CFD3E1' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: '#71747D',
    borderRadius: '20px',
    fontSize: '9pt',
  }));
  
  useEffect(() => {
      if (!items) {
        console.log("No notification yet");
      } else {
        console.log("Notifications:", items);
        setLoading(false);
      }
    }, [items]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <PageLayout>
      <Container className={classes.mainContainer}>
          <Typography className={classes.leftTitle} variant="h6" component="h6">
          Definições Gerais
          </Typography>

          <div className={classes.mixerDiv}>
              <Button 
                  className={classes.mixerButon} 
                  variant="text">
                  <NotificationIcon className={classes.mixerIcon} />
              </Button>
          </div>
      </Container>

      <TabContext value={value} >
        <Box className={classes.notificationTab}>
          <TabList onChange={handleChange} aria-label="Notification tab" className={classes.notificationTabButtons}>
            <Tab label="Não lidas" value="1"  />
            <Tab label="Lidas" value="2" />
          </TabList>
        </Box>
        <TabPanel className={classes.notificationsTabPanel} value="1">
        <Stack className={classes.notificationStack}>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <Item key={item.id}>
              <div className={classes.notificationsBadge}>
                <Badge color="error" badgeContent={" "}/>
              </div>
                <Typography variant="subtitle1" component="subtitle1">
                  {t(prefixString('event', item.type))}
                </Typography>
                <Divider />
                <span>
                  {formatList('alarm', item.attributes.alarms)} <br />
                  {formatList('notificator', item.notificators)}
                </span>
            </Item>
          )) : '' }
          </Stack>

        </TabPanel>
        <TabPanel className={classes.notificationsTabPanel} value="2">
          Nenhuma notificação
        </TabPanel>
      </TabContext>

      {/* <CollectionFab editPath="/settings/notification" /> */}
    </PageLayout>
  );
};

{/* <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{t('notificationType')}</TableCell>
            <TableCell>{t('notificationAlways')}</TableCell>
            <TableCell>{t('sharedAlarms')}</TableCell>
            <TableCell>{t('notificationNotificators')}</TableCell>
            <TableCell className={classes.columnAction} />
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell>{t(prefixString('event', item.type))}</TableCell>
              <TableCell>{formatBoolean(item.always, t)}</TableCell>
              <TableCell>{formatList('alarm', item.attributes.alarms)}</TableCell>
              <TableCell>{formatList('notificator', item.notificators)}</TableCell>
              <TableCell className={classes.columnAction} padding="none">
                <CollectionActions itemId={item.id} editPath="/settings/notification" endpoint="notifications" setTimestamp={setTimestamp} />
              </TableCell>
            </TableRow>
          )) : (<TableShimmer columns={5} endAction />)}
        </TableBody>
      </Table> */}

export default NotificationsPage;
